// Copyright Materialize, Inc. and contributors. All rights reserved.
//
// Use of this software is governed by the Business Source License
// included in the LICENSE file.
//
// As of the Change Date specified in that file, in accordance with
// the Business Source License, use of this software will be governed
// by the Apache License, Version 2.0.

import { DatabaseType } from "./constants";

export function typeToLabel(databaseType: DatabaseType): string {
  if (databaseType === "mysql") {
    return "MySQL";
  } else if (databaseType === "postgres") {
    return "PostgreSQL";
  } else if (databaseType === "sql-server") {
    return "SQL Server";
  }
  throw new Error("Unreachable");
}
